import styled from '@emotion/styled'

type Props = {
  isPrimary: boolean
  isOutline: boolean
  isCleared: boolean
  isDisabled: boolean
  isNoBackground: boolean
  width?: number
  padding?: number
}

type ImplicitTheme = {
  theme: Record<string, any>
}

const disabledStyle = ({ theme }: ImplicitTheme) => `
  background-color: ${theme.ds.ColorBaseGreyLevel2};
  color: ${theme.ds.ColorBaseGreyLevel4};
  border: none;
  cursor: not-allowed;
  box-shadow: none;

  &:hover {
    background-color: ${theme.ds.ColorBaseGreyLevel2};
  }
`

const outlineStyle = ({ theme }: ImplicitTheme) => `
  border: 1px solid;
  border-color: ${theme.ds.ColorBaseGreyLevel4};
  background-color: ${theme.ds.ColorBaseWhite};
  &:hover {
    background-color: ${theme.ds.ColorBaseGreyLevel1};
  }
  :disabled {
    ${disabledStyle}
  }
`

const clearedStyle = ({ theme }: ImplicitTheme) => `
  border: 0;
  background-color: transparent;
  color: ${theme.ds.ColorBaseBlueLevel6};
  padding: 0;

  &:hover {
    background-color: transparent;
  }
  :disabled {
    ${disabledStyle}
    background-color: transparent;
  }
`

const primaryStyle = ({ theme }: ImplicitTheme) => `
  background-color: ${theme.ds.ColorBaseYellowLevel6};
  &:hover {
    background-color: ${theme.ds.ColorBaseYellowLevel6}a6;
  }
`

const noBackgroundStyle = ({ theme }: ImplicitTheme) => `
  border: 2px solid;
  border-color: ${theme.ds.ColorBaseGreyLevel4};
  background-color: transparent;
  font-weight: normal;
  &:hover {
    background-color: transparent;
  }
  :disabled {
    ${disabledStyle}
  }
`

const ButtonDefaultStyle = styled.button<Props>(
  ({ theme, width, padding }) => `
  font-family: inherit;
  height: 48px;
  box-sizing: border-box;
  cursor: pointer;
  outline: none;
  min-width: ${width ?? 130}px;
  max-width: 100%;
  width: ${width ? `${width}px` : 'auto'};
  font-size: 14px;
  color: ${theme.ds.ColorBaseGreyLevel4};
  box-shadow: none;
  border-radius: 24px;
  padding: ${padding ?? '16px 32px'} ;
  font-weight: 500;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  :disabled {
    ${disabledStyle}
  }
`
)

export const BaseButton = styled(ButtonDefaultStyle)`
  ${props => props.isPrimary && primaryStyle}
  ${props => props.isOutline && outlineStyle}
  ${props => props.isCleared && clearedStyle}
  ${props => props.isDisabled && disabledStyle}
  ${props => props.isNoBackground && noBackgroundStyle}
`
